import {useEffect} from 'react';

import VIDABOO_CONSTANTS from '../../../config/consts';

const LAZY_COMPONENTS = {
  [VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.EMOJI_MART_DATA]: () =>
    import('@emoji-mart/data'),
  [VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.EMOJI_MART_REACT]: () =>
    import('@emoji-mart/react'),
  [VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.MOMENT]: () => import('moment'),
  [VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.OT_VIDEO_COMPONENT]: () =>
    import('../../callComponents/otVideo'),
};

const PreloadLazyComponents = ({componentKeys}) => {
  useEffect(() => {
    if (componentKeys && componentKeys.length > 0) {
      const timeoutId = setTimeout(() => {
        componentKeys.forEach((key) => {
          const importFunc = LAZY_COMPONENTS[key];
          if (importFunc) {
            importFunc().catch((err) => {
              console.error(`Failed to preload component ${key}:`, err);
            });
          } else {
            console.warn(`No lazy component found for key: ${key}`);
          }
        });
      }, VIDABOO_CONSTANTS.PRELOAD_DELAY);

      return () => clearTimeout(timeoutId);
    }
  }, []);

  return null;
};

export default PreloadLazyComponents;
